import { Component, HostBinding, Input } from '@angular/core';
import { IconComponent } from '@rivet-health/design-system';
import { ToastType } from './toast.service';

@Component({
  selector: 'toast',
  styleUrls: ['./toast.component.scss'],
  templateUrl: './toast.component.html',
})
export class ToastComponent {
  @HostBinding('class.error')
  get danger() {
    return this.type === 'error';
  }

  @HostBinding('class.success')
  get safety() {
    return this.type === 'success';
  }

  @Input()
  type: ToastType | undefined;

  @Input()
  icon: IconComponent.Name | undefined;
}
